import React, { useEffect, useState } from 'react';
import { baseApiCall } from 'src/api/Api';
import { AlertsModal } from 'src/components/Modals/AlertsModal/AlertsModal';
import { dashboard_alerts } from 'src/constants/url';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import useAuthorizationContext from 'src/providers/AuthorizationHandler/useAuthorizationContext';
import { commonVaribles } from 'src/constants/constVariables';
import { colors } from 'src/assets/scss/partials/colors';

const AlertRadioButton = ({ value, rowData, onCheckChange }) => {
	const SelectedShop = useSelector((state) => state.allshops.shopName?.value);
	const SelectedLine = useSelector((state) => state.allLine.lineName?.value);
	const { user } = useAuthorizationContext();
	const [selectedRadioBtn, setSelectedRadioBtn] = useState(value);
	const [modalInfo, setModalInfo] = useState('');
	const [isWarningModalOpen, setWarningModalIsOpen] = useState(false);

	useEffect(() => {
		if (value === true) {
			setSelectedRadioBtn(commonVaribles.correct);
		} else if (value === false) {
			setSelectedRadioBtn(commonVaribles.cross);
		} else {
			setSelectedRadioBtn(null);
		}
	}, [value]);

	const handleChange = (e) => {
		const target = e.target;
		if (target.value === commonVaribles.correct) {
			setWarningModalIsOpen(true);
			setModalInfo({
				value: target.value,
				color: colors.green,
				title: commonVaribles.alertsResolve_msg,
				heading: 'Alert',
			});
		}
		if (target.value === commonVaribles.cross) {
			setWarningModalIsOpen(true);
			setModalInfo({
				value: target.value,
				color: colors.red,
				title: commonVaribles.alertsUnresolved_msg,
				heading: 'Alert',
			});
		}
	};

	const confirmationChek = (value) => {
		const key = value === commonVaribles.correct ? true : false;
		baseApiCall({
			url: dashboard_alerts.UPDATE_ALERTS_STATUS,
			requestBody: {
				shop_id: SelectedShop ? SelectedShop : '',
				line_id: SelectedLine ? SelectedLine : '',
				id: rowData.id,
				is_action: key,
				updated_by: user.name,
			},
			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res && res.data) {
					onCheckChange();
					setSelectedRadioBtn(value);
				}
			},
			onFailure: () => {},
			errorCall: () => {},
		});
	};

	return (
		<>
			<label style={{ padding: '0px 25px 0px 0px', cursor: 'pointer' }}>
				<input
					type="radio"
					value={commonVaribles.correct}
					checked={selectedRadioBtn === commonVaribles.correct}
					onChange={handleChange}
					hidden
				/>

				<svg
					width="22"
					height="22"
					viewBox="0 0 22 22"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<circle
						cx="11.1271"
						cy="11"
						r="10"
						stroke={
							selectedRadioBtn === commonVaribles.correct
								? colors.light_green
								: colors.black
						}
						strokeWidth="1.5"
						fill={
							selectedRadioBtn === commonVaribles.correct
								? colors.light_green
								: ''
						}
					/>
					<path
						d="M7.62708 11.5L9.62708 13.5L14.6271 8.5"
						stroke={
							selectedRadioBtn === commonVaribles.correct
								? colors.white
								: colors.black
						}
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			</label>

			<label style={{ margin: '10px', cursor: 'pointer' }}>
				<input
					type="radio"
					value={commonVaribles.cross}
					checked={selectedRadioBtn === commonVaribles.cross}
					onChange={handleChange}
					hidden
				/>

				<svg
					width="22"
					height="22"
					viewBox="0 0 22 22"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<circle
						cx="11.1271"
						cy="11"
						r="10"
						stroke={
							selectedRadioBtn === commonVaribles.cross
								? colors.light_red
								: colors.black
						}
						strokeWidth="1.5"
						fill={
							selectedRadioBtn === commonVaribles.cross ? colors.light_red : ''
						}
					/>
					<path
						d="M13.6271 8.50002L8.62708 13.5M8.62705 8.5L13.627 13.5"
						stroke={
							selectedRadioBtn === commonVaribles.cross
								? colors.white
								: colors.black
						}
						strokeWidth="1.5"
						strokeLinecap="round"
					/>
				</svg>
			</label>

			<AlertsModal
				open={isWarningModalOpen}
				handleClose={() => setWarningModalIsOpen(false)}
				confirmationChek={() => confirmationChek(modalInfo.value)}
				title={modalInfo.title}
				color={modalInfo.color}
				value={modalInfo.value}
				header={modalInfo.heading}
			/>
		</>
	);
};

AlertRadioButton.propTypes = {
	rowData: PropTypes.object.isRequired,
	value: PropTypes.bool.isRequired,
};

export default AlertRadioButton;
